export enum EPromptState {
  LOGIN_FORM,
  SIGNUP_FORM,
}
